import { getOrgName, getTenantFromSubdomain } from '../../../../utils/appendOrgQuery';

export default function requestInterceptor(api) {
  api.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem('Token');
    const selectedOrganization = getOrgName();
    const tenant = getTenantFromSubdomain();
    const isPublicAPI = config.url?.startsWith('/public/');

    if (!isPublicAPI) {
      if (tenant) {
        config.headers.tenant = tenant;
      }
      if (selectedOrganization) {
        config.headers.organization = selectedOrganization;
      }
      if (accessToken) {
        config.headers.Authorization = `bearer ${accessToken}`;
      }
    }

    return config;
  });
}
